"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: profile/profile-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fprofile%2Fprofile-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileServiceClient = exports.UpdatePublicPayLinkEnabledResponse = exports.UpdatePublicPayLinkEnabledRequest = exports.GetRestrictedProfileResponse = exports.GetRestrictedProfileRequest = exports.SetProfileResponse = exports.SetProfileRequest = exports.GetProfileResponse = exports.GetProfileRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const profile_profile_1 = require("./profile-profile");
const protobufPackage = 'com.step.profile.proto';
function createBaseGetProfileRequest() {
    return {};
}
exports.GetProfileRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetProfileRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetProfileRequest();
        return message;
    },
};
function createBaseGetProfileResponse() {
    return { profile: undefined };
}
exports.GetProfileResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.profile)) {
            message.profile = profile_profile_1.Profile.fromJSON(object.profile);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.profile !== undefined) {
            obj.profile = profile_profile_1.Profile.toJSON(message.profile);
        }
        return obj;
    },
    create(base) {
        return exports.GetProfileResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProfileResponse();
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? profile_profile_1.Profile.fromPartial(object.profile)
            : undefined;
        return message;
    },
};
function createBaseSetProfileRequest() {
    return { status: profile_profile_1.Status.INVALID_STATUS };
}
exports.SetProfileRequest = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status) ? (0, profile_profile_1.statusFromJSON)(object.status) : profile_profile_1.Status.INVALID_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== profile_profile_1.Status.INVALID_STATUS) {
            obj.status = (0, profile_profile_1.statusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.SetProfileRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetProfileRequest();
        message.status = object.status ?? profile_profile_1.Status.INVALID_STATUS;
        return message;
    },
};
function createBaseSetProfileResponse() {
    return {};
}
exports.SetProfileResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetProfileResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetProfileResponse();
        return message;
    },
};
function createBaseGetRestrictedProfileRequest() {
    return {};
}
exports.GetRestrictedProfileRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetRestrictedProfileRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetRestrictedProfileRequest();
        return message;
    },
};
function createBaseGetRestrictedProfileResponse() {
    return { profile: undefined };
}
exports.GetRestrictedProfileResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.profile)) {
            message.profile = profile_profile_1.Profile.fromJSON(object.profile);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.profile !== undefined) {
            obj.profile = profile_profile_1.Profile.toJSON(message.profile);
        }
        return obj;
    },
    create(base) {
        return exports.GetRestrictedProfileResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRestrictedProfileResponse();
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? profile_profile_1.Profile.fromPartial(object.profile)
            : undefined;
        return message;
    },
};
function createBaseUpdatePublicPayLinkEnabledRequest() {
    return { enabled: false };
}
exports.UpdatePublicPayLinkEnabledRequest = {
    fromJSON(object) {
        const message = {
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.UpdatePublicPayLinkEnabledRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdatePublicPayLinkEnabledRequest();
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseUpdatePublicPayLinkEnabledResponse() {
    return {};
}
exports.UpdatePublicPayLinkEnabledResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdatePublicPayLinkEnabledResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdatePublicPayLinkEnabledResponse();
        return message;
    },
};
/**
 * Profile management API
 *
 * Manages profile (Pay Me Page)
 */
class ProfileServiceClient {
    rpc;
    name = 'com.step.profile.proto.ProfileService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/profile';
    methods = [{
            name: 'GetProfile',
            requestType: exports.GetProfileRequest,
            responseType: exports.GetProfileResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetProfile',
            requestType: exports.SetProfileRequest,
            responseType: exports.SetProfileResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetRestrictedProfile',
            requestType: exports.GetRestrictedProfileRequest,
            responseType: exports.GetRestrictedProfileResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
        }, {
            name: 'UpdatePublicPayLinkEnabled',
            requestType: exports.UpdatePublicPayLinkEnabledRequest,
            responseType: exports.UpdatePublicPayLinkEnabledResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get profile. Used for authenticated users who owns the public profile.
     */
    getProfile(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set profile. Used when users update their pubic profile's state.
     */
    setProfile(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Looks up profile, including non-public profile data for users over 13
     */
    getRestrictedProfile(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update user public pay link enabled.
     */
    updatePublicPayLinkEnabled(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ProfileServiceClient = ProfileServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=profile-service.js.map